export default {
  title: 'Angebotsbild',
  select: {
    generate_title: 'Bild mit KI generieren',
    generate_subtitle: 'Wir erstellen eines basierend auf deinen Angebotsdetails.',
    generate_cta: 'Generieren',
    upload_link: 'oder von deinem Gerät hochladen',
    rate_limit_company: {
      title: 'Kurze Verschnaufpause',
      description: 'Dein Restaurant hat in dieser Stunde schon viele Bilder generiert. Versuche es in {{time}} erneut.',
    },
    rate_limit_offer: {
      title: 'Kurz durchatmen',
      description: 'Du hast dieses Angebot mehrfach hintereinander generiert. Wir sind in {{time}} wieder bereit.',
    },
  },
  generating: {
    title: 'Dein Bild wird generiert…',
    progress: {
      cooking: 'Wir bereiten etwas Leckeres zu…',
      plating: 'Anrichten…',
      finishing: 'Letzter Schliff…',
    },
  },
  preview: {
    alt: 'Generiertes Angebotsbild',
    hint: 'Nicht ganz passend? Neu generieren oder zum Zuschneiden fortfahren.',
    click_to_expand: 'Zum Vergrößern klicken',
    regenerate: 'Neu generieren',
    continue: 'Zum Bearbeiten',
  },
  toasts: {
    upload_success: 'Bild erfolgreich hochgeladen.',
    upload_failed: 'Bild konnte nicht hochgeladen werden.',
    delete_success: 'Bild erfolgreich gelöscht.',
    delete_failed: 'Bild konnte nicht gelöscht werden.',
    generate_success: 'Bild erfolgreich generiert.',
    generate_failed: 'Bildgenerierung konnte nicht gestartet werden.',
    generate_timeout: 'Das Bild wird noch generiert. Es erscheint hier, sobald es fertig ist.',
    rate_limit_company: 'Stundenlimit für dieses Restaurant erreicht. Versuche es in {{time}} erneut.',
    rate_limit_offer: 'Zu viele Versuche hintereinander für dieses Angebot — versuche es in {{time}} erneut.',
  },
  time: {
    seconds_one: '1 Sekunde',
    seconds_other: '{{count}} Sekunden',
    minutes_one: '1 Minute',
    minutes_other: '{{count}} Minuten',
    hours_one: '1 Stunde',
    hours_other: '{{count}} Stunden',
  },
};
